import axiosInstance from '@/core/api'
import {
	CreateCommissionCashbackRequest,
	CreateCommissionCashbackResponse,
	CreateDepositPromotionRequest,
	CreateDepositPromotionResponse,
	CreateReturnLossRequest,
	CreateReturnLossResponse,
	GetCommissionCashbackByIdResponse,
	GetCommissionCashbackRequest,
	GetCommissionCashbackResponse,
	GetDailyCheckInResponse,
	GetDepositPromotionByIdResponse,
	GetDepositPromotionRequest,
	GetDepositPromotionResponse,
	GetLuckyWheelResponse,
	GetReturnLossByIdResponse,
	GetReturnLossRequest,
	GetReturnLossResponse,
	UpdateCommissionCashbackResponse,
	UpdateDailyCheckInRequest,
	UpdateDailyCheckInResponse,
	UpdateLuckyWheelRequest,
	UpdateLuckyWheelResponse,
	UpdateDepositPromotionResponse,
	UpdateReturnLossRequest,
	UpdateReturnLossResponse,
	GetInviteFriendResponse,
	UpdateInviteFriendRequest,
	UpdateInviteFriendResponse,
	UpdateCommissionCashbackRequest,
	GetDailyCheckInByIdResponse,
	CreateDailyCheckInRequest,
	CreateDailyCheckInResponse,
	GetDailyCheckInRequest,
	GetDepositPromotionNamesForSelectorResponse,
	GetReturnLossNameResponse,
	GetDailyCheckInNameResponse,
	GetCommissionNameResponse,
	UpdateDepositPromotionRequest,
	SpinLuckyWheelResponse,
	GetPresetIdResponse,
	GetDepositPromotionNamesForSelectorCouponResponse,
	GetDailyPlayerReturnLossRequest,
	GetDailyPlayerReturnLossResponse,
	GetReturnLossHistoryRequest,
	GetReturnLossHistoryResponse,
	GetInviteFriendCommissionHistoryRequest,
	GetInviteFriendCommissionHistoryResponse,
	GetDepositPromotionPresetsResponse,
	ApplyDepositPromotionPresetRequest,
	ApplyDepositPromotionPresetResponse,
	GetLuckyWheelImagePresetsResponse,
} from '../../type'

// Commission Cashback
export const getCommissionCashbackList = async (
	payload: GetCommissionCashbackRequest,
): Promise<GetCommissionCashbackResponse> => {
	const response = await axiosInstance.get<GetCommissionCashbackResponse>(
		'/admin/commission-cashback',
		{ params: payload },
	)
	return response.data
}

export const getCommissionCashbackById = async (
	id: string,
): Promise<GetCommissionCashbackByIdResponse> => {
	const response = await axiosInstance.get<GetCommissionCashbackByIdResponse>(
		`/admin/commission-cashback/${id}`,
	)
	return response.data
}

export const createCommissionCashback = async (
	payload: CreateCommissionCashbackRequest,
): Promise<CreateCommissionCashbackResponse> => {
	const response = await axiosInstance.post<CreateCommissionCashbackResponse>(
		'/admin/commission-cashback',
		payload,
	)
	return response.data
}

export const updateCommissionCashback = async (
	id: string,
	payload: UpdateCommissionCashbackRequest,
): Promise<UpdateCommissionCashbackResponse> => {
	const response = await axiosInstance.patch<UpdateCommissionCashbackResponse>(
		`/admin/commission-cashback/${id}`,
		payload,
	)
	return response.data
}

export const deleteCommissionCashback = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(
		`/admin/commission-cashback/${id}`,
	)
	return response.data
}

// Daily Check-in
export const getDailyCheckIn = async (
	payload: GetDailyCheckInRequest,
): Promise<GetDailyCheckInResponse> => {
	const response = await axiosInstance.get<GetDailyCheckInResponse>(
		'/admin/daily-check-in',
		{ params: payload },
	)
	return response.data
}

export const getDailyCheckInById = async (
	id: string,
): Promise<GetDailyCheckInByIdResponse> => {
	const response = await axiosInstance.get<GetDailyCheckInByIdResponse>(
		`/admin/daily-check-in/${id}`,
	)
	return response.data
}

export const createDailyCheckIn = async (
	payload: CreateDailyCheckInRequest,
): Promise<CreateDailyCheckInResponse> => {
	const response = await axiosInstance.post<CreateDailyCheckInResponse>(
		'/admin/daily-check-in',
		payload,
	)
	return response.data
}

export const updateDailyCheckIn = async (
	id: string,
	payload: UpdateDailyCheckInRequest,
): Promise<UpdateDailyCheckInResponse> => {
	const response = await axiosInstance.patch<UpdateDailyCheckInResponse>(
		`/admin/daily-check-in/${id}`,
		payload,
	)
	return response.data
}

// Deposit Promotion
export const getDepositPromotionList = async (
	payload: GetDepositPromotionRequest,
): Promise<GetDepositPromotionResponse> => {
	const response = await axiosInstance.get<GetDepositPromotionResponse>(
		'/admin/deposit-promotions',
		{ params: payload },
	)
	return response.data
}

export const getDepositPromotionById = async (
	id: string,
): Promise<GetDepositPromotionByIdResponse> => {
	const response = await axiosInstance.get<GetDepositPromotionByIdResponse>(
		`/admin/deposit-promotions/${id}`,
	)
	return response.data
}

export const createDepositPromotion = async (
	payload: CreateDepositPromotionRequest,
): Promise<CreateDepositPromotionResponse> => {
	const response = await axiosInstance.post<CreateDepositPromotionResponse>(
		'/admin/deposit-promotions',
		payload,
	)
	return response.data
}

export const updateDepositPromotion = async (
	id: string,
	payload: UpdateDepositPromotionRequest,
): Promise<UpdateDepositPromotionResponse> => {
	const response = await axiosInstance.patch<UpdateDepositPromotionResponse>(
		`/admin/deposit-promotions/${id}`,
		payload,
	)
	return response.data
}

export const deleteDepositPromotion = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(
		`/admin/deposit-promotions/${id}`,
	)
	return response.data
}

// Invite Friend
export const getInviteFriend = async (): Promise<GetInviteFriendResponse> => {
	const response = await axiosInstance.get<GetInviteFriendResponse>(
		'/admin/invite-friend/setting',
	)
	return response.data
}

export const updateInviteFriend = async (
	payload: UpdateInviteFriendRequest,
): Promise<UpdateInviteFriendResponse> => {
	const response = await axiosInstance.patch<UpdateInviteFriendResponse>(
		'/admin/invite-friend/setting',
		payload,
	)
	return response.data
}

// Lucky Wheel
export const getLuckyWheel = async (): Promise<
	GetLuckyWheelResponse & { remainingAttempts: number }
> => {
	const response = await axiosInstance.get<
		GetLuckyWheelResponse & { remainingAttempts: number }
	>('/admin/lucky-wheel')
	return response.data
}

export const getLuckyWheelImagePresets = async (
	type?: 'wheel' | 'arrow',
): Promise<GetLuckyWheelImagePresetsResponse> => {
	const response = await axiosInstance.get<GetLuckyWheelImagePresetsResponse>(
		'/admin/lucky-wheel/image-presets',
		{ params: type ? { type } : undefined },
	)
	return response.data
}

export const updateLuckyWheel = async (
	payload: UpdateLuckyWheelRequest,
): Promise<UpdateLuckyWheelResponse> => {
	const response = await axiosInstance.patch<UpdateLuckyWheelResponse>(
		'/admin/lucky-wheel',
		payload,
	)
	return response.data
}

// Return Loss
export const getReturnLossList = async (
	payload: GetReturnLossRequest,
): Promise<GetReturnLossResponse> => {
	const response = await axiosInstance.get<GetReturnLossResponse>(
		'/admin/return-loss',
		{ params: payload },
	)
	return response.data
}

export const getReturnLossById = async (
	id: string,
): Promise<GetReturnLossByIdResponse> => {
	const response = await axiosInstance.get<GetReturnLossByIdResponse>(
		`/admin/return-loss/${id}`,
	)
	return response.data
}

export const createReturnLoss = async (
	payload: CreateReturnLossRequest,
): Promise<CreateReturnLossResponse> => {
	const response = await axiosInstance.post<CreateReturnLossResponse>(
		'/admin/return-loss',
		payload,
	)
	return response.data
}

export const updateReturnLoss = async (
	id: string,
	payload: UpdateReturnLossRequest,
): Promise<UpdateReturnLossResponse> => {
	const response = await axiosInstance.patch<UpdateReturnLossResponse>(
		`/admin/return-loss/${id}`,
		payload,
	)
	return response.data
}

export const deleteReturnLoss = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(`/admin/return-loss/${id}`)
	return response.data
}

export const getDepositPromotionNamesForSelector =
	async (): Promise<GetDepositPromotionNamesForSelectorResponse> => {
		const response =
			await axiosInstance.get<GetDepositPromotionNamesForSelectorResponse>(
				'/admin/deposit-promotions/selector/names',
			)
		return response.data
	}

export const getDepositPromotionNamesForSelectorChannel =
	async (): Promise<GetDepositPromotionNamesForSelectorResponse> => {
		const response =
			await axiosInstance.get<GetDepositPromotionNamesForSelectorResponse>(
				'/admin/deposit-promotions/selector/names/channel',
			)
		return response.data
	}

export const getDepositPromotionNamesForSelectorCoupon =
	async (): Promise<GetDepositPromotionNamesForSelectorCouponResponse> => {
		const response =
			await axiosInstance.get<GetDepositPromotionNamesForSelectorCouponResponse>(
				'/admin/deposit-promotions/selector/names/coupon',
			)
		return response.data
	}

export const getDepositPromotionNamesForBrokeNotification =
	async (): Promise<GetDepositPromotionNamesForSelectorResponse> => {
		const response =
			await axiosInstance.get<GetDepositPromotionNamesForSelectorResponse>(
				'/admin/deposit-promotions/broke-notification',
			)
		return response.data
	}

export const getCommissionName =
	async (): Promise<GetCommissionNameResponse> => {
		const response = await axiosInstance.get<GetCommissionNameResponse>(
			'/admin/commission-cashback/selector/names',
		)
		return response.data
	}

export const getReturnLossName =
	async (): Promise<GetReturnLossNameResponse> => {
		const response = await axiosInstance.get<GetReturnLossNameResponse>(
			'/admin/return-loss/selector/names',
		)
		return response.data
	}

export const getDailyCheckInName =
	async (): Promise<GetDailyCheckInNameResponse> => {
		const response = await axiosInstance.get<GetDailyCheckInNameResponse>(
			'/admin/daily-check-in/selector/names',
		)
		return response.data
	}

export const spinLuckyWheel = async (): Promise<SpinLuckyWheelResponse> => {
	const response = await axiosInstance.post<SpinLuckyWheelResponse>(
		'/admin/lucky-wheel/test',
	)
	return response.data
}

export const getPresetId = async (): Promise<GetPresetIdResponse> => {
	const response = await axiosInstance.get<GetPresetIdResponse>(
		'/admin/deposit-promotions/presets',
	)
	return response.data
}

// Daily Player Return Loss
export const getDailyPlayerReturnLossList = async (
	payload: GetDailyPlayerReturnLossRequest,
): Promise<GetDailyPlayerReturnLossResponse> => {
	const response = await axiosInstance.get<GetDailyPlayerReturnLossResponse>(
		'/admin/return-loss/daily-player-return-loss',
		{ params: payload },
	)
	return response.data
}

// Return Loss History
export const getReturnLossHistoryList = async (
	payload: GetReturnLossHistoryRequest,
): Promise<GetReturnLossHistoryResponse> => {
	const response = await axiosInstance.get<GetReturnLossHistoryResponse>(
		'/admin/return-loss/history',
		{ params: payload },
	)
	return response.data
}

// Invite Friend Commission History
export const getInviteFriendCommissionHistoryList = async (
	payload: GetInviteFriendCommissionHistoryRequest,
): Promise<GetInviteFriendCommissionHistoryResponse> => {
	const response =
		await axiosInstance.get<GetInviteFriendCommissionHistoryResponse>(
			'/admin/invite-friend/commission-history',
			{ params: payload },
		)
	return response.data
}

// Deposit Promotion Presets
export const getDepositPromotionPresets =
	async (): Promise<GetDepositPromotionPresetsResponse> => {
		const response =
			await axiosInstance.get<GetDepositPromotionPresetsResponse>(
				'/admin/deposit-promotions/promotion-presets',
			)
		return response.data
	}

export const applyDepositPromotionPreset = async (
	presetId: string,
	payload: ApplyDepositPromotionPresetRequest,
): Promise<ApplyDepositPromotionPresetResponse> => {
	const response =
		await axiosInstance.post<ApplyDepositPromotionPresetResponse>(
			`/admin/deposit-promotions/promotion-presets/${presetId}/apply`,
			payload,
		)
	return response.data
}
